class DiscountCodeManager extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('.discount-form');
    this.input = this.querySelector('.discount-input');
    this.button = this.querySelector('.discount-apply-btn');
    this.message = this.querySelector('.discount-message');
    this.removeButtons = this.querySelectorAll('.discount-remove');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  connectedCallback() {
    this.form.addEventListener('submit', this.handleApply.bind(this));
    this.removeButtons.forEach((btn) => {
      btn.addEventListener('click', this.handleRemove.bind(this));
    });
  }

  async handleApply(e) {
    e.preventDefault();

    const discountCode = this.input.value.trim();

    if (!discountCode) {
      this.showMessage('Please enter a discount code', 'error');
      return;
    }

    this.button.disabled = true;
    this.button.textContent = 'Applying...';

    try {
      const formData = new FormData();
      formData.append('discount', discountCode);

      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        const responseData = await response.text();
        publish(PUB_SUB_EVENTS.cartUpdate, { cartData: responseData });
      } else {
        this.showMessage('Invalid discount code', 'error');
      }
    } catch (error) {
      this.showMessage('Error applying discount code', 'error');
      console.error('Error:', error);
    } finally {
      this.button.disabled = false;
      this.button.textContent = 'Apply';
    }
  }

  async handleRemove(e) {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append('discount', '');

      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        const responseData = await response.text();
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: responseData });

        this.input.value = '';
      }
    } catch (error) {
      this.showMessage('Error removing discount code', 'error');
      console.error('Error:', error);
    }
  }

  showMessage(text, type) {
    this.message.textContent = text;
    this.message.className = 'discount-message ' + type;

    setTimeout(() => {
      this.message.textContent = '';
      this.message.className = 'discount-message';
    }, 3000);
  }
}

customElements.define('discount-code-manager', DiscountCodeManager);
